import { IInputDataType } from '@modeso/types__aumico-lib-notes-be/dist/models/enums/input-type.enum';
import { RowTypes } from '../../enums/pdf-tron/row-types.enum';

export interface IFinancialTableData {
    rowType: RowTypes;
    t: string | null;
    r?: string | null;
    pV?: string | null;
    pP?: string | null;
    cV?: string | null;
    cF?: string | null;
    cP?: string | null;
    /**
     * FX (REV-21512): the display-currency twins of cV/pV on an FLI note in the `both` state.
     * Absent on non-FX reports and in the other states — the DOCX template ignores unknown tags
     * (nullGetter), so the physical {cV}{pV} table stays untouched until the second Guss.
     */
    cV2?: string | null;
    pV2?: string | null;
    level?: number | null;
    disableNumbering?: boolean;
    currentDateTitle?: string;
    previousDateTitle?: string;
    extraHeader1?: string;
    extraHeader2?: string;
    dataType?: IInputDataType;
    compareYears?: boolean;
    id?: string;
}
